import React, { Component } from "react"
import { Link } from "gatsby"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import AOS from "aos"
import 'aos/dist/aos.css';
import NewsStrip from "../../components/news-strip";
import mainImg from "../../images/pcv-drivers.jpg";
import driverImg from "../../images/bus-coach-driver-jobs.jpg";
import arrowSvg from "../../images/arrow-circle-right-solid.svg"

class JobsPage extends Component {

  componentDidMount() {
    AOS.init();
    window.addEventListener('load', AOS.refresh);
    // @NOTE: Hack to force AOS to work :(
    window.setTimeout(AOS.refresh, 1000);
  }

  componentDidUpdate() {
    AOS.refresh();
  }

  render() {
    return (
      <Layout>
        <SEO title="Jobs at Tetley's Coaches Leeds" description="Find your next career at Tetley's Coaches - Leeds' oldest coach operator established 1949." />
        <div className="block-services inner-body-bg">
          <div className="body gutter page-content-parent page-article headblock">
            <h1 className="headblock__heading">Jobs</h1>
            <p className="headblock__byline">Find a career with Tetley's Coaches</p>
          </div>
          <div className="body gutter page-article page-content-parent">
            <h2 data-aos='fade-left' data-aos-duration="500" style={{ marginBottom: 20 }}>Current vacancies</h2>
            <div className="page-content">
              <div className="page-content__text" style={{ width: '100%' }}>
                <img src={mainImg} alt="PCV drivers" />

                <p>Tetley’s Coaches are currently recruiting a number of roles to join our team at our <strong>Leeds depot</strong>. We operate a variety of <strong>private hire, contract, and school bus services</strong>, providing high-quality transport solutions across the region.</p>
                <div className="content-box" style={{ width: '100%', maxWidth: '100%', marginBottom: '1.5em' }}>
                  <h3 style={{ marginBottom: '1em' }}>PCV Driver – Full Time</h3>
                  <p>Tetley's Motor Services is recruiting Full-Time PCV Drivers to join our established team. This position offers a guaranteed 35-hour week, with plenty of opportunity for overtime across private hire, contract work and major events.</p>
                  <Link className='btn btn-grow btn-others btn-small' to="/jobs/pcv-bus-coach-driver-leeds/">
                    <span className='btn-others__text'>View job</span>
                    <img className='btn-others__icon' src={arrowSvg} alt="" />
                  </Link>
                </div>
                <div className="content-box" style={{  width: '100%', maxWidth: '100%', marginBottom: '1em' }}>
                  <h3 style={{ marginBottom: '1em' }}>PCV School Bus Driver – Part Time</h3>
                  <p>
                    We’re hiring Part-Time School Bus Drivers for a set Monday–Friday school run. A dedicated vehicle, the same route each day, and a calm, predictable role suited to semi-retired drivers or anyone seeking improved work–life balance.
                  </p>
                  <Link className='btn btn-grow btn-others btn-small' to="/jobs/pcv-school-bus-driver-part-time-leeds/">
                    <span className='btn-others__text'>View job</span>
                    <img className='btn-others__icon' src={arrowSvg} alt="" />
                  </Link>
                </div>
                <div className="content-box" style={{  width: '100%', maxWidth: '100%', marginBottom: '1em' }}>
                  <h3 style={{ marginBottom: '1em' }}>Mechanic – Full Time</h3>
                  <p>
                    Tetley’s Motor Services is recruiting for a full-time Mechanic to join our established team. This position offers a 40-hour week, with opportunity for occasional overtime.
                  </p>
                  <Link className='btn btn-grow btn-others btn-small' to="/jobs/mechanic-leeds/">
                    <span className='btn-others__text'>View job</span>
                    <img className='btn-others__icon' src={arrowSvg} alt="" />
                  </Link>
                </div>

              </div>

            </div>
          </div>
        </div>

        <NewsStrip />

      </Layout>
    );
  }
}

export default JobsPage
